import {
  POSTED_JOB_VIEW_REQUEST, POSTED_JOB_VIEW_FAIL, POSTED_JOB_VIEW_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const PostedJobViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case POSTED_JOB_VIEW_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case POSTED_JOB_VIEW_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case POSTED_JOB_VIEW_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default PostedJobViewReducer;
